<!-- NavigationTabs.vue -->
<template>
  <div class="navigation-tabs-container mb-3">
    <div class="btn-group d-flex flex-wrap" role="group" aria-label="Navigation tabs">
      <button
        v-for="tab in tabs"
        :key="tab.id"
        type="button"
        class="btn navigation-tab me-2 mb-2"
        :class="{ 'active': value === tab.id }"
        @click="handleTabClick(tab)">
        {{ tab.label }}
      </button>
    </div>
    <div v-if="showActionButton" class="mt-2">
      <button
        class="btn btn-primary btn-sm"
        :data-bs-toggle="actionButtonConfig.toggle"
        :data-bs-target="actionButtonConfig.target">
        {{ actionButtonConfig.label }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationTabs',
  props: {
    value: {
      type: String,
      required: true
    },
    tabs: {
      type: Array,
      required: true,
      validator: (tabs) => {
        return tabs.every(tab =>
            typeof tab.id === 'string' &&
            typeof tab.label === 'string' &&
            typeof tab.event === 'string'
        );
      }
    },
    showActionButton: {
      type: Boolean,
      default: false
    },
    actionButtonConfig: {
      type: Object,
      default: () => ({
        label: '+ Add New',
        toggle: 'modal',
        target: '#defaultModal'
      })
    }
  },
  methods: {
    handleTabClick(tab) {
      this.$emit('input', tab.id);
      this.$emit('tab-click', tab);
    },
  }
}
</script>

<style scoped>
.navigation-tabs-container {
  width: 100%;
}

.navigation-tab {
  background-color: #2c3e50;
  color: #cccccc;
  border: 1px solid #4a5568;
  transition: all 0.2s;
  font-weight: 500;
  padding: 0.5rem 1rem;
}

.navigation-tab:hover {
  background-color: #3a5275;
  color: white;
  transform: translateY(-2px);
}

.navigation-tab.active {
  background-color: #1f6dff;
  color: white;
  font-weight: 600;
  border-color: #1f6dff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>